<div class="product-detail">
	<button type="button" class="btn btn-sm btn-outline-secondary mb-3" (click)="closed.emit()">
		<i class="wq wq-chevron-left mr-2"></i>Back to results
	</button>

	<ui-wait *ngIf="loading"></ui-wait>

	<ng-container *ngIf="!loading && detail">
		<!-- Headline block: the same shape the product screens use, so a product reads the same wherever it's opened. -->
		<div class="bg-white border border-lightgrey rounded p-3 mb-2">
			<div class="d-flex">
				<div class="mr-4 shrink">
					<div class="img-container border border-2 border-lightergrey rounded"
						[style.backgroundImage]="'url(\'' + (product.image_url || 'assets/img/image-placeholder.png') + '\')' | safeStyle">
						<div *ngIf="product.catalogue_image_url"
							class="cat-image-fixed border bg-white border-silver rounded-circle shadow-sm"
							[style.backgroundImage]="'url(\'' + product.catalogue_image_url + '\')' | safeStyle"
							[ngbTooltip]="product.catalogue_name"></div>
					</div>
					<!-- The same badge the results grid shows in place of a bundle's price. -->
					<div *ngIf="product.is_bundle" class="mt-2">
						<span class="badge bg-purple-15 text-purple text-tiny"><i class="wq wq-configure mr-1"></i>Configure for price</span>
					</div>
					<div *ngIf="classification" class="text-secondary text-tiny mt-2">{{classification}}</div>
				</div>

				<div class="flex-weight-1">
					<div class="d-flex align-items-end mb-3">
						<div class="flex-weight-1 pr-4">
							<div class="text-secondary text-small">Product Description</div>
							<h4 class="text-bold mb-0">{{product.short_description}}</h4>
							<div *ngIf="title" class="text-secondary text-small mt-1">{{title}}</div>
						</div>
						<div class="text-bold nowrap">Cost Details</div>
					</div>

					<div class="d-flex">
						<div class="flex-weight-1 d-flex flex-wrap">
							<div *ngFor="let f of fields" class="mb-3 pr-4" style="width: 33.33%;">
								<div class="text-secondary text-small">{{f.label}}</div>
								<div class="text-bold text-truncate" [title]="f.value">{{f.value || '-'}}</div>
							</div>
						</div>

						<div class="w-15r pl-4 border-left border-1">
							<div class="mb-2">
								<div class="text-secondary text-small">Cost on catalogue</div>
								<div class="text-bold">{{canSeeCosts ? (costs.cost_price | currencyFlexible:currencyId) : '—'}}</div>
							</div>
							<div class="mb-2">
								<div class="text-secondary text-small">{{product.is_bundle ? 'Base price' : 'Sell price'}}<span *ngIf="costs.pricing_structure"> ({{costs.pricing_structure}})</span></div>
								<div class="text-bold">{{costs.sell_price | currencyFlexible:currencyId}}</div>
								<!-- A bundle's line keeps this price and each option picked goes on as a line of its own. -->
								<div *ngIf="product.is_bundle" class="text-secondary text-tiny">Options are priced on top</div>
							</div>
							<div class="mb-2">
								<div class="text-secondary text-small">SRP / MSRP</div>
								<div class="text-bold">{{costs.srp_price | currencyFlexible:currencyId}}</div>
							</div>
							<div *ngIf="canSeeCosts">
								<div class="text-secondary text-small">Margin</div>
								<div class="text-bold" [ngClass]="costs.margin >= 0 ? 'text-success' : 'text-primary'">{{costs.margin | decimal:0:1}}%</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<hr style="border-width: 1px;">

			<div class="d-flex align-items-start">
				<div class="mr-4">
					<div class="text-bold mb-2">Your Warehouse Stock</div>
					<div class="d-flex">
						<div class="mr-4">
							<div class="text-secondary text-small">Stock on Hand</div>
							<div class="badge badge-success px-3 mt-1 text-small">{{availability.on_hand | decimal:0:4:true}}</div>
						</div>
						<div class="mr-4">
							<div class="text-secondary text-small">Allocated Stock</div>
							<div class="badge badge-warning px-3 mt-1 text-small">{{availability.allocated | decimal:0:4:true}}</div>
						</div>
						<div>
							<div class="text-secondary text-small">Free Stock</div>
							<div class="badge badge-lightergrey text-dark px-3 mt-1 text-small">{{availability.free | decimal:0:4:true}}</div>
						</div>
					</div>
				</div>

				<div class="flex-weight-1"></div>

				<!-- There is no default distributor, so the card acts against whichever one is picked below. -->
				<div *ngIf="selected" class="w-20r border border-lightgrey rounded p-3">
					<div class="d-flex align-items-center">
						<ui-avatar-stack class="mr-2" [items]="[selected]" [max]="1" fallbackName="My Products"></ui-avatar-stack>
						<div class="flex-weight-1">
							<div class="text-bold text-truncate" [title]="selected.name">{{selected.name || 'My Products'}}</div>
							<div class="text-secondary text-tiny text-truncate" [title]="selected.sku">{{selected.sku || '-'}}</div>
							<span *ngIf="selected.discontinued" class="badge badge-danger text-tiny mt-1">Discontinued</span>
						</div>
						<div class="text-bold nowrap ml-2">{{selected.sell_price | currencyFlexible:selected.currency_id}}</div>
					</div>
					<button *ngIf="canAdd" type="button" class="btn btn-sm btn-block mt-3" [ngClass]="isAdded(selected) ? 'btn-outline-success' : 'btn-primary'" (click)="addDistributor(selected)"><i *ngIf="isAdded(selected)" class="wq wq-check mr-2"></i>{{isAdded(selected) ? 'Added to quote' : 'Add to quote'}}</button>
				</div>
			</div>
		</div>

		<!-- Tabs, the same shape the product details modal uses. -->
		<div class="d-flex mb-4">
			<div *ngFor="let t of tabList"
				class="px-3 py-3 flex-weight-1 selectable hoverable border-bottom d-flex align-items-center"
				[ngClass]="{ 'border-primary border-4': activeTab === t.id, 'border-lightgrey': activeTab !== t.id }"
				(click)="selectTab(t)">
				<span class="text-uppercase text-small text-bold" [ngClass]="{ 'text-secondary': activeTab !== t.id }">{{t.title}}</span>
			</div>
		</div>

		<!-- Only Suppliers comes with the panel; the rest are fetched when their tab is opened. -->
	<div *ngIf="sectionLoading" class="d-flex align-items-center justify-content-center py-5">
		<div class="spinner-border text-secondary"></div>
	</div>

	<!-- Suppliers: discontinued status and the name each one gives the product are held per distributor. -->
		<ng-container *ngIf="activeTab === 'suppliers'">
			<table class="table table-hover">
				<thead>
					<tr>
						<th class="text-dark shrink"></th>
						<th class="text-dark">Distributor</th>
						<th class="text-dark" colspan="2">Product</th>
						<th class="text-dark">Supplier SKU</th>
						<th class="text-dark">Price</th>
						<th class="text-dark">Distributor Stock</th>
						<th class="text-dark shrink"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let d of distributors" class="selectable" [ngClass]="{ 'bg-primary-10': d.product_id === selectedProductId }" (click)="selectDistributor(d)">
						<td class="shrink align-middle">
							<ui-avatar-stack [items]="[d]" [max]="1" fallbackName="My Products"></ui-avatar-stack>
						</td>
						<td class="align-middle">
							<div class="text-bold">{{d.name || 'My Products'}}</div>
							<span *ngIf="d.discontinued" class="badge badge-danger text-tiny mt-1">Discontinued</span>
							<span *ngIf="d.special_order" class="badge badge-lightergrey text-secondary text-tiny mt-1 ml-1">Special order</span>
						</td>
						<!-- The same identifier block the results row shows, on the copy's own data: two distributors
						     carrying one product routinely disagree on its name, manufacturer, model and codes. -->
						<td class="shrink pr-0 align-middle">
							<div *ngIf="d.image_url" class="product-image mr-3" [style.backgroundImage]="'url(\'' + d.image_url + '\')' | safeStyle"></div>
						</td>
						<td class="pl-0 align-middle">
							<div class="text-bold">{{d.short_description || '-'}}</div>
							<div *ngIf="supplierBrand(d)" class="text-secondary">{{supplierBrand(d)}}</div>
							<div *ngIf="supplierCodes(d)" class="text-secondary text-tiny">{{supplierCodes(d)}}</div>
							<!-- Held on the copy, not on the group: the colours the product list uses for the same two
							     counts, accessories green and labour purple. -->
							<div *ngIf="d.accessories_count || d.labour_count" class="d-flex align-items-center mt-1">
								<span *ngIf="d.accessories_count" class="text-success text-bold text-tiny nowrap mr-2">{{d.accessories_count}} {{d.accessories_count === 1 ? 'accessory' : 'accessories'}}</span>
								<span *ngIf="d.labour_count" class="text-purple text-bold text-tiny nowrap">{{d.labour_count}} labour</span>
							</div>
						</td>
						<td class="align-middle text-small">{{d.sku || '-'}}</td>
						<td class="align-middle">
							<div class="text-bold">{{d.sell_price | currencyFlexible:d.currency_id}}</div>
							<div *ngIf="canSeeCosts" class="text-secondary text-tiny nowrap">Cost {{d.cost_price | currencyFlexible:d.currency_id}}</div>
						</td>
						<td class="align-middle">
							<span *ngIf="d.stock !== null" class="badge d-inline-block text-tiny px-3" [ngClass]="d.stock > 0 ? 'badge-success' : 'badge-danger'">{{d.stock | decimal:0}}</span>
							<span *ngIf="d.stock === null" class="text-secondary text-tiny">N/A</span>
						</td>
						<td class="shrink align-middle nowrap">
							<button type="button" class="btn btn-sm btn-outline-secondary text-tiny mr-2 border-0" ngbTooltip="Edit product" placement="top" (click)="editProduct.emit(d.product_id); $event.stopPropagation()"><i class="wq wq-edit"></i></button>
							<button *ngIf="canAdd" type="button" class="btn btn-sm text-tiny" [ngClass]="isAdded(d) ? 'btn-outline-success' : 'btn-primary'" (click)="addDistributor(d); $event.stopPropagation()"><i *ngIf="isAdded(d)" class="wq wq-check mr-1"></i>{{isAdded(d) ? 'Added' : 'Add to quote'}}</button>
						</td>
					</tr>
					<tr *ngIf="!distributors.length">
						<td colspan="8" class="text-secondary">No distributor carries this product.</td>
					</tr>
				</tbody>
			</table>
			<div class="text-secondary text-tiny">
				Discontinued status, product naming and the identifiers are all held per distributor. There is no default distributor &mdash; take the action against the distributor you want to buy from.
			</div>
		</ng-container>

		<!-- Attachments: what auto-attaches to a quote line, plus the documents held against the product. -->
		<ng-container *ngIf="activeTab === 'attachments' && !sectionLoading">
			<div class="d-flex align-items-start">
				<div class="flex-weight-1 pr-4">
					<div class="text-bold">Accessories</div>
					<div class="text-secondary text-small mb-2">Items added here auto attach to this item when it's added to a proposal.</div>

					<table class="table table-hover">
						<tbody>
							<tr *ngFor="let a of accessories" class="selectable" (click)="openProduct.emit(a.product_id)">
								<td class="shrink pr-0 align-middle">
									<div *ngIf="a.image_url" class="product-image mr-3" [style.backgroundImage]="'url(\'' + a.image_url + '\')' | safeStyle"></div>
								</td>
								<td class="pl-0 align-middle">
									<div class="text-bold">{{a.short_description}}</div>
									<div class="text-secondary text-small">{{a.manufacturer_name}}<span *ngIf="a.manufacturer_name && a.sku"> / </span>{{a.sku}}</div>
								</td>
								<td class="align-middle text-right text-secondary text-small nowrap">&times; {{a.default_quantity | decimal:0:4:true}}</td>
								<td class="align-middle text-right text-bold nowrap">{{a.sell_price | currencyFlexible:a.currency_id}}</td>
							</tr>
							<tr *ngIf="!accessories.length">
								<td class="text-secondary">No accessories attached.</td>
							</tr>
						</tbody>
					</table>

					<div class="text-bold">Labour</div>
					<div class="text-secondary text-small mb-2">Labour paired with this item comes across onto the quote line with it.</div>

					<table class="table table-hover">
						<thead>
							<tr>
								<th class="text-dark">Labour type</th>
								<th class="text-dark text-right">Hours</th>
								<th class="text-dark text-right">Rate</th>
								<th class="text-dark text-right">Total</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let l of labour">
								<td class="text-bold">{{l.description}}</td>
								<td class="text-right">{{l.hours | decimal:0:2:true}}</td>
								<td class="text-right">{{l.hourly_price | currencyFlexible:l.currency_id}}</td>
								<td class="text-right text-bold">{{l.total_price | currencyFlexible:l.currency_id}}</td>
							</tr>
							<tr *ngIf="!labour.length">
								<td colspan="4" class="text-secondary">No labour paired with this product.</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="w-20r border border-lightgrey rounded p-3">
					<div class="text-uppercase text-tiny text-secondary mb-2">Documents</div>
					<div *ngFor="let d of documents" class="d-flex align-items-center py-2 border-top">
						<i class="wq wq-document-search text-secondary mr-2"></i>
						<a class="flex-weight-1 text-dark text-truncate" [href]="d.url | safeUrl" target="_blank" [title]="d.name">{{d.name}}</a>
						<span class="text-secondary text-tiny ml-2">{{d.type}}</span>
					</div>
					<div *ngIf="!documents.length" class="text-secondary text-small">No documents.</div>
				</div>
			</div>
		</ng-container>

		<!-- Specification: the organisation's own settings, then what each distributor publishes for the same product. -->
		<ng-container *ngIf="activeTab === 'specification' && !sectionLoading">
			<div class="text-bold mb-3">Our specification</div>
			<div class="d-flex flex-wrap">
				<div *ngFor="let row of specification" class="mb-3 pr-4" style="width: 25%;">
					<div class="text-secondary text-small">{{row.label}}</div>
					<div class="text-bold">{{row.value}}</div>
				</div>
			</div>

			<div *ngIf="flags.length" class="d-flex flex-wrap mb-4">
				<span *ngFor="let flag of flags" class="badge badge-lightergrey text-dark font-weight-normal mr-2 px-2 py-1">{{flag}}</span>
			</div>

			<div class="text-bold">Distributor specifications</div>
			<div class="text-secondary text-small mb-2">Each distributor publishes its own data for this product &mdash; one open at a time.</div>

			<div class="border border-lightgrey rounded">
				<div *ngFor="let d of distributors" class="border-bottom">
					<div class="d-flex align-items-center p-3 selectable hoverable" (click)="toggleSpec(d)">
						<i class="wq mr-2 text-secondary" [ngClass]="openSpecId === d.product_id ? 'wq-caret-down' : 'wq-caret-right'"></i>
						<ui-avatar-stack class="mr-2" [items]="[d]" [max]="1" fallbackName="My Products"></ui-avatar-stack>
						<div class="flex-weight-1">
							<div class="text-bold">{{d.name || 'My Products'}}</div>
							<div class="text-secondary text-small">{{d.short_description}}</div>
						</div>
						<span *ngIf="d.discontinued" class="badge badge-danger text-tiny mr-3">Discontinued</span>
						<div class="text-bold nowrap">{{d.sell_price | currencyFlexible:d.currency_id}}</div>
					</div>

					<div *ngIf="openSpecId === d.product_id" class="d-flex flex-wrap px-3 pb-3 pl-5">
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Description</div>
							<div class="text-bold">{{d.short_description || '-'}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Manufacturer</div>
							<div class="text-bold">{{d.manufacturer_name || '-'}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Model</div>
							<div class="text-bold">{{d.model || '-'}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">EAN</div>
							<div class="text-bold">{{d.ean || '-'}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Manufacturer SKU</div>
							<div class="text-bold">{{d.manufacturer_sku || '-'}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Supplier SKU</div>
							<div class="text-bold">{{d.sku || '-'}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Unit of Measure</div>
							<div class="text-bold">{{d.unit_name || '-'}}</div>
						</div>
						<div *ngIf="canSeeCosts" class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Cost price</div>
							<div class="text-bold">{{d.cost_price | currencyFlexible:d.currency_id}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">{{product.is_bundle ? 'Base price' : 'Sell price'}}<span *ngIf="d.plevel"> ({{d.plevel}})</span></div>
							<div class="text-bold">{{d.sell_price | currencyFlexible:d.currency_id}}</div>
							<div *ngIf="product.is_bundle" class="text-secondary text-tiny">Options are priced on top</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">SRP / MSRP</div>
							<div class="text-bold">{{d.srp_price | currencyFlexible:d.currency_id}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Live distributor stock</div>
							<div class="text-bold">{{d.stock === null ? 'N/A' : ((d.stock | decimal:0) + ' available')}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">On order</div>
							<div class="text-bold">{{d.stock_ordered === null ? '-' : (d.stock_ordered | decimal:0)}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Pack quantity</div>
							<div class="text-bold">{{d.pack_quantity}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Currency</div>
							<div class="text-bold">{{d.currency_id}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Catalogue</div>
							<div class="text-bold">{{d.name || 'My Products'}}</div>
						</div>
						<div class="mb-3 pr-4" style="width: 33.33%;">
							<div class="text-secondary text-small">Lifecycle</div>
							<div class="text-bold">{{d.discontinued ? 'Discontinued' : 'Actively supplied'}}</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

		<!-- Stock: where the product physically is, on the same figures the stock tab reports. -->
		<ng-container *ngIf="activeTab === 'stock' && !sectionLoading">
			<div class="text-secondary text-small mb-2" *ngIf="warehouses.length">
				{{availability.on_hand | decimal:0:4:true}} on hand across
				{{availability.warehouse_count}} {{availability.warehouse_count === 1 ? 'warehouse or site' : 'warehouses and sites'}}
				&middot; {{availability.free | decimal:0:4:true}} free
				&middot; {{availability.allocated | decimal:0:4:true}} allocated
			</div>

			<table class="table table-hover">
				<thead>
					<tr>
						<th class="text-dark">Warehouse or site</th>
						<th class="text-dark">Serialised</th>
						<th class="text-dark text-right">On hand</th>
						<th class="text-dark text-right">Free</th>
						<th class="text-dark text-right">Allocated</th>
						<th class="text-dark text-right">Reserved</th>
						<th class="text-dark text-right nowrap">Min / Max / Reorder</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let w of warehouses">
						<td>
							<div class="d-flex align-items-center">
								<i class="wq wq-warehouse text-secondary mr-2"></i>
								<a *ngIf="warehouseLink(w); else plainWarehouse" class="text-dark" target="_blank" [routerLink]="warehouseLink(w)">{{w.name}}</a>
								<ng-template #plainWarehouse><span class="text-dark">{{w.name}}</span></ng-template>
							</div>
							<div class="text-secondary text-tiny text-capitalize">{{warehouseTypeLabel(w)}}<span *ngIf="w.sku"> &middot; {{w.sku}}</span></div>
						</td>
						<td>
							<span class="badge text-tiny" [ngClass]="w.is_serialised ? 'badge-purple' : 'badge-lightergrey text-secondary'">{{w.is_serialised ? 'Serialised' : 'Non-serialised'}}</span>
						</td>
						<td class="text-right text-bold">{{w.on_hand | decimal:0:4:true}}</td>
						<td class="text-right text-bold text-success">{{w.free | decimal:0:4:true}}</td>
						<td class="text-right text-bold text-info">{{w.allocated | decimal:0:4:true}}</td>
						<td class="text-right text-bold text-warning">{{w.reserved | decimal:0:4:true}}</td>
						<td class="text-right text-secondary text-small nowrap">{{thresholds(w) || '-'}}</td>
					</tr>
					<tr *ngIf="!warehouses.length">
						<td colspan="7" class="text-secondary">This product is not held in any warehouse or site.</td>
					</tr>
				</tbody>
			</table>

			<!-- Locations, allocations, reservations and serials, each grouped by the warehouse holding them. -->
			<div class="d-flex flex-wrap">
				<div *ngFor="let section of stockSections" class="w-50 pr-3 pb-3">
					<div class="border border-lightgrey rounded p-3 h-100">
						<div class="d-flex align-items-center mb-2">
							<span class="text-uppercase text-tiny text-secondary flex-weight-1">{{section.name}}</span>
							<span class="badge badge-lightergrey text-secondary text-tiny">{{section.count}}</span>
						</div>

						<div *ngIf="!section.warehouses?.length" class="text-secondary text-small">Nothing recorded.</div>

						<div *ngFor="let group of section.warehouses" class="mb-3">
							<div class="d-flex align-items-center">
								<i class="wq wq-warehouse text-secondary mr-2"></i>
								<!-- The heading opens the warehouse's stocked item list. -->
								<a *ngIf="sectionLink(group); else plainGroup" class="text-bold text-primary flex-weight-1 text-truncate" target="_blank"
									[routerLink]="sectionLink(group)" [title]="group.link_label">{{group.name}}</a>
								<ng-template #plainGroup>
									<span class="text-bold flex-weight-1 text-truncate" [title]="group.name">{{group.name}}</span>
								</ng-template>
								<span *ngIf="group.badge" class="badge text-tiny text-uppercase nowrap ml-2" [ngClass]="'badge-' + (group.badge_class || 'secondary')">{{group.badge}}</span>
							</div>
							<div *ngIf="group.meta" class="text-secondary text-tiny mb-1 text-truncate" [title]="group.meta">{{group.meta}}</div>

							<div *ngFor="let line of group.lines" class="d-flex align-items-start py-1 border-top">
								<!-- Quantity is skipped where a line is one unit by definition, e.g. a serial. -->
								<span *ngIf="line.quantity !== null && line.quantity !== undefined" class="badge badge-lightergrey text-dark text-tiny mr-2 nowrap">&times; {{line.quantity | decimal:0:4:true}}</span>
								<div class="flex-weight-1">
									<div class="d-flex align-items-center">
										<!-- The reference opens the record the line came from, e.g. the stock request behind an allocation. -->
										<a *ngIf="line.ref && refLink(line)" class="badge badge-lightergrey text-dark font-weight-normal mr-2 nowrap" target="_blank"
											[routerLink]="refLink(line)" [title]="line.ref_link_label">{{line.ref}}</a>
										<span *ngIf="line.ref && !refLink(line)" class="badge badge-lightergrey text-dark font-weight-normal mr-2 nowrap">{{line.ref}}</span>
										<!-- A location opens the stocked item list scoped to it; a commitment opens its project. -->
										<a *ngIf="sectionLink(line); else plainLine" class="text-dark flex-weight-1 text-truncate" target="_blank"
											[routerLink]="sectionLink(line)" [title]="line.link_label || line.title">{{line.title}}</a>
										<ng-template #plainLine>
											<span class="flex-weight-1 text-truncate" [title]="line.title">{{line.title}}</span>
										</ng-template>
										<span *ngIf="line.badge" class="badge text-tiny text-uppercase ml-2 nowrap" [ngClass]="'badge-' + (line.badge_class || 'secondary')">{{line.badge}}</span>
									</div>
									<div *ngIf="line.meta" class="text-secondary text-tiny text-truncate" [title]="line.meta">{{line.meta}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div *ngIf="!stockSections.length && warehouses.length" class="text-secondary text-small">No location breakdown recorded.</div>
			</div>
		</ng-container>

		<!-- Customers: scoped to this product only - the customers search tab searches customer records. -->
		<ng-container *ngIf="activeTab === 'customers' && !sectionLoading">
			<table class="table table-hover">
				<thead>
					<tr>
						<th class="text-dark">Customer</th>
						<th class="text-dark">Where it is used</th>
						<th class="text-dark">Documents</th>
						<th class="text-dark text-right">Units</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let c of usageCustomers">
						<td>
							<a *ngIf="customerLink(c); else plainCustomer" class="text-bold text-dark" target="_blank" [routerLink]="customerLink(c)">{{c.name}}</a>
							<ng-template #plainCustomer><span class="text-bold">{{c.name}}</span></ng-template>
							<div *ngIf="c.account_no" class="text-secondary text-tiny">{{c.account_no}}</div>
						</td>
						<td class="text-small">{{customerWhere(c)}}</td>
						<td class="text-small">
							<ng-container *ngIf="c.documents.length; else noDocuments">
								<a *ngIf="documentLink(c.documents[0].link); else plainDocument"
									class="d-block text-truncate text-dark" target="_blank"
									[routerLink]="documentLink(c.documents[0].link)" [title]="c.documents[0].label">{{c.documents[0].label}}</a>
								<ng-template #plainDocument>
									<div class="text-truncate" [title]="c.documents[0].label">{{c.documents[0].label}}</div>
								</ng-template>
							</ng-container>
							<ng-template #noDocuments><div>&mdash;</div></ng-template>
							<div *ngIf="c.documents.length > 1" class="text-secondary text-tiny">+{{c.documents.length - 1}} more</div>
						</td>
						<td class="text-right text-bold">{{c.units | decimal:0:4:true}}</td>
					</tr>
					<tr *ngIf="!usageCustomers.length">
						<td colspan="4" class="text-secondary">No customer has this product on a quote, project or invoice yet.</td>
					</tr>
				</tbody>
			</table>
			<div class="text-secondary text-tiny">Scoped to this product only &mdash; the Customers search tab searches customer records</div>
		</ng-container>

		<!-- Users: who has quoted, ordered or requested this product before. -->
		<ng-container *ngIf="activeTab === 'users' && !sectionLoading">
			<table class="table table-hover">
				<thead>
					<tr>
						<th class="text-dark">User</th>
						<th class="text-dark">What they did with it</th>
						<th class="text-dark">Most recent</th>
						<th class="text-dark text-right">Units</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let u of usageUsers">
						<td class="d-flex align-items-center">
							<ui-user-image class="mr-3" [email]="u.email_addr" size="2.5rem"></ui-user-image>
							<div class="text-bold">{{u.name}}</div>
						</td>
						<td class="text-small">{{userWhat(u)}}</td>
						<td class="text-small text-secondary">
							<ng-container *ngIf="u.last; else noRecent">
								<a *ngIf="documentLink(u.last_link); else plainRecent"
									class="text-dark" target="_blank" [routerLink]="documentLink(u.last_link)">{{u.last}}</a>
								<ng-template #plainRecent>{{u.last}}</ng-template>
								<span *ngIf="u.last_age"> &middot; {{u.last_age}}</span>
							</ng-container>
							<ng-template #noRecent>&mdash;</ng-template>
						</td>
						<td class="text-right text-bold">{{u.units | decimal:0:4:true}}</td>
					</tr>
					<tr *ngIf="!usageUsers.length">
						<td colspan="4" class="text-secondary">No user has quoted, ordered or requested this product yet.</td>
					</tr>
				</tbody>
			</table>
			<div class="text-secondary text-tiny">Scoped to this product only &mdash; the Users search tab searches user records</div>
		</ng-container>
	</ng-container>
</div>
